<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在获取提现信息....">
      <a-form class="ant-advanced-search-form">
        <a-row class="searchrow width-style-auto">
          <a-col span="4">
            <a-form-item :colon="false" label="提现状态">
              <a-select v-model="search.status" placeholder="请选择提现状态">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option v-for="e in init.statuses" :key="e.id" :value="e.id">{{e.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="申请日期">
              <a-date-picker v-model="search.startDate" placeholder="请选择申请开始日期" style="width: 120px;"/>至<a-date-picker v-model="search.endDate" placeholder="请选择申请结束日期" style="width: 120px;"/>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item :colon="false">
              <img src="../../../assets/img/s-q.png" style="margin-right: 20px;cursor: pointer;" @click="searchAction">
              <a-button style="height: 28px;" @click="backAction">返回</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-row class="search"></a-row>
      <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}" rowKey="id" :dataSource="grid.data"
               :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">
        <span slot="index" slot-scope="text, record, index">
           {{(((grid.pagination.current -1 ) * grid.pagination.pageSize) + index + 1) }}
        </span>
        <span slot="operate" slot-scope="text, record, index">
          <a @click="()=>detailAction(record.id)">详情</a>
        </span>
      </a-table>
    </a-spin>
    <a-drawer placement="right" :closable="true" :mask-closable="false" :visible="detail.visible"
              width="600" :body-style="{'padding':'12px','box-sizing':'border-box','height':'92%','overflow':'auto'}">
      <div slot="title" class="gpws-drawer-title-span">
        <div class="gpws-drawer-close" @click="()=>onDetailClose()"><a-icon type="close" style="margin-right: 3px" />关闭</div>
        <span class="gpws-drawer-title">提现详情</span>
        <span></span>
      </div>
      <a-row>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="申请单位(人)" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.customer }}
          </a-form-item>
        </a-col>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="银行开户名" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.name }}
          </a-form-item>
        </a-col>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="银行账号" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.account }}
          </a-form-item>
        </a-col>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="开户银行" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            <template v-if="detail.record.bank === 'ABC'">
              <img src="../../../assets/img/abc.png" width="24" height="24" style="margin-right: 12px;">农业银行
            </template>
            <template v-if="detail.record.bank === 'BC'">
              <img src="../../../assets/img/bc.png" width="24" height="24" style="margin-right: 12px;">中国银行
            </template>
            <template v-if="detail.record.bank === 'CCB'">
              <img src="../../../assets/img/ccb.png" width="24" height="24" style="margin-right: 12px;">建设银行
            </template>
            <template v-if="detail.record.bank === 'ICBC'">
              <img src="../../../assets/img/icbc.png" width="24" height="24" style="margin-right: 12px;">工商银行
            </template>
            <template v-if="detail.record.bank === 'CMB'">
              <img src="../../../assets/img/cmb.png" width="24" height="24" style="margin-right: 12px;">招商银行
            </template>
            <template v-if="detail.record.bank === 'CMBC'">
              <img src="../../../assets/img/cmbc.png" width="24" height="24" style="margin-right: 12px;">民生银行
            </template>
            <template v-if="detail.record.bank === 'OTHER'">
              其它银行
            </template>
            <span style="margin-left: 12px;">{{detail.record.openBank}}</span>
          </a-form-item>
        </a-col>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="提现金额" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ (detail.record.amount||0).toFixed(2) }} 元
          </a-form-item>
        </a-col>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="申请人" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.applicant }}
          </a-form-item>
        </a-col>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="联系方式" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.mobile }}
          </a-form-item>
        </a-col>
        <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="申请时间" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.applyTime }}
          </a-form-item>
        </a-col>
        <a-col v-if="detail.record.status ==='PAID' || detail.record.status ==='FINISHED'" :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="支付人" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.cashier }}
          </a-form-item>
        </a-col>
        <a-col v-if="detail.record.status ==='PAID' || detail.record.status ==='FINISHED'" :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="支付时间" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
            {{ detail.record.paidTime }}
          </a-form-item>
        </a-col>
        <a-col v-if="detail.record.status ==='PAID' || detail.record.status ==='FINISHED'" :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-form-item label="支付凭证" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
          </a-form-item>
        </a-col>
        <a-col v-if="detail.record.status ==='PAID' || detail.record.status ==='FINISHED'" :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <img :src="detail.record.pic" style="width: 100%; height: auto;"/>
        </a-col>
      </a-row>
    </a-drawer>
  </div>
</template>

<script>
export default {
  name: "ClinicWithdraw",
  data(){
    return {
      loading:false,
      current:{},
      init:{
        statuses:[{id:'NEW', name:'新申请'}, {id:'PAID', name:'已支付'}, {id:'FINISHED', name:'已完成'}, {id:'CANCELLED', name:'已取消'}],
      },
      detail:{
        visible:false,
        record:{}
      },
      search:{
        status:'',
        startDate:'',
        endDate:''
      },
      grid: {
        loading: false,
        columns: columns,
        data: [],
        pagination: this.$pagination
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "分账管理",
      path: ""
    },{
      text: "提现列表",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.searchAction();
  },
  methods:{
    backAction:function (){
      this.$router.push({ path : '/layout/system/account' });
    },
    detailAction:function (id) {
      const self = this;
      this.$axios.get('/api/clinic/account/withdraw/' + id).then(function (res) {
        if (res.msg.flag == 0) {
          if(undefined != res.biz && null != res.biz){
            self.detail.record = res.biz;
            self.detail.visible = true;
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
      });
    },
    onDetailClose:function (){
      this.detail.record={};
      this.detail.visible = false;
    },
    buildParams:function (){
      let startDate = '', endDate = '';
      if(undefined != this.search.startDate && null != this.search.startDate && '' != this.search.startDate){
        startDate = this.formatDate(new Date(this.search.startDate));
      }
      if(undefined != this.search.endDate && null != this.search.endDate && '' != this.search.endDate){
        endDate = this.formatDate(new Date(this.search.endDate));
      }
      return {
        'entity.customerId':this.current.organId, startTime : startDate, endTime : endDate, 'entity.status' : this.search.status
      };
    },
    /**
     * 查询按钮动作
     */
    searchAction: function () {
      const self = this;
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid:function(params){
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/account/withdraws', {params: params}).then(function(res){
        self.grid.loading = false;
        if(res.msg.flag == 0){
          if(null == res.biz || res.biz.empty){
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          }else{
            Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.grid.loading = false;
      });
    }
  }
}

const columns=[
  {
    title: '序号',
    align: 'center',
    scopedSlots: {customRender: 'index'},
    width: 60
  },
  {
    title: '申请时间',
    dataIndex: 'applyTime',
    key: 'applyTime',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '状态',
    dataIndex: 'statusName',
    key: 'statusName',
    align: 'center',
    width: 100,
    customRender:(text, record, index) =>{
      return (text == null || text == undefined || text == '') ? '-' : text;
    }
  },
  {
    title: '提现金额',
    dataIndex: 'amount',
    key: 'amount',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text.toFixed(2);
    }
  },
  {
    title: '申请人',
    dataIndex: 'applicant',
    key: 'applicant',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '支付财务',
    dataIndex: 'cashier',
    key: 'cashier',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '支付时间',
    dataIndex: 'paidTime',
    key: 'paidTime',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '操作',
    key: 'id',
    align: 'center',
    fixed: 'right',
    width: 100,
    scopedSlots: {customRender: 'operate'}
  }
];
</script>

<style scoped>

</style>